export var raTreeLanguageEnglish = {
    'ra-tree': {
        drag_preview: 'Node #%{id} |||| Node #%{id} with %{smart_count} children',
        root_target: 'Drop an item here to make it top level',
        item_moved: 'Item moved',
        new_node: 'New node',
        action: {
            add_root: 'Add root',
            add_child: 'Add child',
        },
    },
};
export default raTreeLanguageEnglish;
